import {
  AlertModalService,
  FlashMessageService,
  ModalService,
  SubModalService,
} from "@policoders/ds";
import LoaderService from "@shared/components/loader/loader.service";

export class UiService {
  modal: ModalService;
  subModal: SubModalService;
  alert: AlertModalService;
  loader: LoaderService;
  flashMessage: FlashMessageService;

  constructor(
    modalService: ModalService,
    subModalService: SubModalService,
    alertService: AlertModalService,
    loader: LoaderService,
    flashMessageService: FlashMessageService,
  ) {
    this.modal = modalService;
    this.subModal = subModalService;
    this.alert = alertService;
    this.loader = loader;
    this.flashMessage = flashMessageService;
  }
}
